import React from 'react'
import { Popup } from 'semantic-ui-react'

import constants from 'config/constants'
import { truncateTextByCharacters } from 'libs/text'
import Title from 'shared/components/Title'

import './styles.css'

export interface PageHeaderProps {
  /**
   * Visible h1 + browser tab title. Pass `''` while async data is
   * loading (e.g. custom dashboard name) — Helmet is skipped on
   * empty so the previous tab title is preserved.
   */
  title: string
  leftSlot?: React.ReactNode
  rightSlot?: React.ReactNode
  showSubMenuToggle?: boolean
  onOpenSubMenu?: () => void
}

export default function PageHeader({
  title,
  leftSlot,
  rightSlot,
  showSubMenuToggle = false,
  onOpenSubMenu,
}: PageHeaderProps) {
  return (
    <>
      {title && <Title title={title} />}
      <div className="page-header">
        <div className="page-header__left">
          {showSubMenuToggle && (
            <Popup
              basic
              size="mini"
              position="top center"
              className="ss-page-header-sidebar-popup"
              inverted
              trigger={
                <button
                  className="!mr-2 !rounded !px-2 !py-1 border-0 cursor-pointer bg-transparent hover:bg-[#F4F7F9]"
                  onClick={onOpenSubMenu}
                >
                  <img
                    src={constants.simplesatClosedSidebarUrl}
                    alt="Side-bar-icon"
                    className="ss-page-header-sidebar-icon"
                  />
                </button>
              }
            >
              Open sidebar
            </Popup>
          )}
          <h1>{truncateTextByCharacters(title, 50)}</h1>
          {leftSlot}
        </div>
        <div className="page-header__right">{rightSlot}</div>
      </div>
    </>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/PageHeader/index.tsx